type TranslationKeys = {
  BACK_TO_LOG_IN: string;
  CANCEL: string;
  CONFIRM: string;
  CODE_HAS_BEEN_SENT: string;
  CODE: string;
  LOST_CODE: string;
  RESEND_CODE: string;
  CONFIRMATION_CODE: string;
  CONFIRM_SMS_CODE: string;
  CONFIRM_SIGN_UP: string;
  CREATE_ACCOUNT: string;
  CREATE_NEW_ACCOUNT: string;
  EMAIL_PLACEHOLDER: string;
  EMAIL: string;
  ERROR_UNKNOWN: string;
  FORGOT_YOUR_PASSWORD: string;
  LOGIN_TO_ACCOUNT: string;
  LOGIN_WITH_BANKID: string;
  LOGIN: string;
  NATIONAL_IDENTITY_PLACEHOLDER: string;
  NATIONAL_IDENTITY: string;
  NEW_PASSWORD_PLACEHOLDER: string;
  NEW_PASSWORD: string;
  PASSWORD_PLACEHOLDER: string;
  PASSWORD: string;
  PHONE_NUMBER_PLACEHOLDER: string;
  PHONE_NUMBER: string;
  REQUIRED: string;
  RESET_PASSWORD: string;
  RESET_YOUR_PASSWORD: string;
  SUBMIT: string;
  UNABLE_TO_LOGIN: string;
  MISSING_ROLES: string;
  NAME_USER_ID: string;
  SEND_CODE: string;
  WRONG_SMS_CODE: string;
  EXPIRED_SMS_CODE: string;
  LOGIN_WITH_QRCODE: string;
  LOGIN_WITH_QRCODE_STEPS_0: string;
  LOGIN_WITH_QRCODE_STEPS_1: string;
  LOGIN_WITH_QRCODE_STEPS_2: string;
  CREATE_QR_CODE: string;
  SIGN_IN_WITH_PERSONAL_NUMBER: string;
  SIGN_IN_TEST: string;
  LOGIN_WITH_BANKID_ON_THIS_DEVICE: string;
  PASSKEY_AUTHENTICATE: string;
  PASSKEY_REGISTER: string;
  PASSKEY_LOGIN_FAILED: string;
  PASSKEY_OPT_OUT: string;
  PASSKEY_NOT_SUPPORTED: string;
  LOGIN_METHOD_DIVIDER: string;
  WITH_BANKID_QR_CODE: string;
  WITH_BANKID_SAME_DEVICE: string;
  WITH_EMAIL: string;
  WITH_PASSKEY: string;
  WITH_MAGIC_LOGIN: string;
  CONFIRM_PASSWORD: string;
  CONFIRM_PASSWORD_PLACEHOLDER: string;
  PASSWORDS_DO_NOT_MATCH: string;
  CODE_RESENT_SUCCESS: string;
};

type Translation = { [K in keyof TranslationKeys]: string };
type LocaleTranslation = {
  [K in keyof TranslationKeys]: string | null;
};
export type TranslationKey = keyof TranslationKeys;

const en: Translation = {
  BACK_TO_LOG_IN: "Back to log in",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
  CODE: "Code",
  CONFIRMATION_CODE: "Confirmation code",
  LOST_CODE: "Lost your code?",
  RESEND_CODE: "Resend code",
  SEND_CODE: "Resend code",
  CODE_HAS_BEEN_SENT: "A code has been sent to your email.",
  CONFIRM_SMS_CODE: "Confirm SMS code",
  CONFIRM_SIGN_UP: "Confirm sign up",
  CREATE_ACCOUNT: "Create account",
  CREATE_NEW_ACCOUNT: "Create a new account",
  EMAIL_PLACEHOLDER: "Enter your email",
  EMAIL: "Email*",
  ERROR_UNKNOWN: "Unknown error",
  FORGOT_YOUR_PASSWORD: "Forgot your password?",
  LOGIN_TO_ACCOUNT: "Login to your account",
  LOGIN_WITH_BANKID: "Sign in with BankID",
  LOGIN_WITH_QRCODE: "Sign in with QR code",
  LOGIN_WITH_QRCODE_STEPS_0: "Click Create QR code.",
  LOGIN_WITH_QRCODE_STEPS_1: "Open the BankID app on your device.",
  LOGIN_WITH_QRCODE_STEPS_2: "Scan the QR code and sign in.",
  LOGIN: "Sign in",
  NATIONAL_IDENTITY_PLACEHOLDER: "Enter personal identity number",
  NATIONAL_IDENTITY: "Personal identity number",
  NEW_PASSWORD_PLACEHOLDER: "New password",
  NEW_PASSWORD: "New password",
  PASSWORD_PLACEHOLDER: "Enter your password",
  PASSWORD: "Password*",
  PHONE_NUMBER_PLACEHOLDER: "Enter phone number",
  PHONE_NUMBER: "Phone number",
  REQUIRED: "Required*",
  RESET_PASSWORD: "Reset",
  RESET_YOUR_PASSWORD: "Reset your password",
  UNABLE_TO_LOGIN: "Your account has been created!",
  MISSING_ROLES:
    "To finish setting it up, send your user ID to the system administrator.",
  NAME_USER_ID: "Here is your user ID: ",
  SUBMIT: "Submit",
  WRONG_SMS_CODE: "Incorrect SMS code",
  EXPIRED_SMS_CODE: "Expired SMS code",
  CREATE_QR_CODE: "Create QR code",
  SIGN_IN_WITH_PERSONAL_NUMBER: "Sign in with personal identity number",
  SIGN_IN_TEST: "Sign in as a tester with user ID",
  LOGIN_WITH_BANKID_ON_THIS_DEVICE: "Use BankID on this device",
  PASSKEY_AUTHENTICATE: "Sign in with passkey",
  PASSKEY_REGISTER: "Register with passkey",
  PASSKEY_LOGIN_FAILED: "Failed to authenticate with passkey",
  PASSKEY_OPT_OUT: "Do not ask me about passkeys",
  PASSKEY_NOT_SUPPORTED: "Passkeys are not supported on this device",
  LOGIN_METHOD_DIVIDER: "OR",
  WITH_BANKID_QR_CODE: "With BankID QR-code",
  WITH_BANKID_SAME_DEVICE: "With BankID on this device",
  WITH_EMAIL: "With Email",
  WITH_PASSKEY: "With Passkey",
  WITH_MAGIC_LOGIN: "With 🪄Magic login🦄",
  CONFIRM_PASSWORD: "Confirm password",
  CONFIRM_PASSWORD_PLACEHOLDER: "Confirm your password",
  PASSWORDS_DO_NOT_MATCH: "Passwords do not match",
  CODE_RESENT_SUCCESS: "Code has been resent to your email",
};

const sv: LocaleTranslation = {
  BACK_TO_LOG_IN: "Tillbaka till inloggningssidan",
  CANCEL: "Avbryt",
  CONFIRM: "Bekräfta",
  CODE: "Kod",
  CONFIRMATION_CODE: "Verifieringskod",
  LOST_CODE: "Tappat bort din kod?",
  RESEND_CODE: "Skicka kod igen",
  SEND_CODE: "Skicka kod",
  CODE_HAS_BEEN_SENT: "En kod har skickats till din e-postadress",
  CONFIRM_SMS_CODE: "Bekräfta sms-kod",
  CONFIRM_SIGN_UP: "Bekräfta registrering",
  CREATE_ACCOUNT: "Skapa ett konto",
  CREATE_NEW_ACCOUNT: "Skapa ett nytt konto",
  EMAIL_PLACEHOLDER: "Ange din e-postadress",
  EMAIL: "E-postadress*",
  ERROR_UNKNOWN: "Okänt fel",
  FORGOT_YOUR_PASSWORD: "Glömt ditt lösenord?",
  LOGIN_TO_ACCOUNT: "Logga in på ditt konto",
  LOGIN_WITH_BANKID: "Logga in med BankID",
  LOGIN: "Logga in",
  NATIONAL_IDENTITY_PLACEHOLDER: "Ange personnummer",
  NATIONAL_IDENTITY: "Personnummer",
  NEW_PASSWORD_PLACEHOLDER: "Nytt lösenord",
  NEW_PASSWORD: "Nytt lösenord",
  PASSWORD_PLACEHOLDER: "Ange ditt lösenord",
  PASSWORD: "Lösenord*",
  PHONE_NUMBER_PLACEHOLDER: "Ange mobilnummer",
  PHONE_NUMBER: "Mobilnummer",
  REQUIRED: "*Obligatoriska uppgifter",
  RESET_PASSWORD: "Återställ lösenord",
  RESET_YOUR_PASSWORD: "Återställ ditt lösenord",
  UNABLE_TO_LOGIN: "Ditt konto har skapats!",
  MISSING_ROLES:
    "Skicka ditt användar-id till din kontaktperson för att färdigställa ditt konto.",
  NAME_USER_ID: "Ditt användar-id är: ",
  SUBMIT: "Skicka",
  WRONG_SMS_CODE: "Felaktig SMS kod",
  EXPIRED_SMS_CODE: "Utgången SMS kod",
  LOGIN_WITH_QRCODE: "Logga in med QR-kod",
  LOGIN_WITH_QRCODE_STEPS_0: "Klicka på Skapa QR-kod.",
  LOGIN_WITH_QRCODE_STEPS_1: "Öppna BankID-appen på din enhet.",
  LOGIN_WITH_QRCODE_STEPS_2: "Skanna QR-koden och logga in.",
  CREATE_QR_CODE: "Skapa QR-kod ",
  SIGN_IN_WITH_PERSONAL_NUMBER: "Logga in med personnummer",
  SIGN_IN_TEST: "Logga in som testare med användar-ID",
  LOGIN_WITH_BANKID_ON_THIS_DEVICE: "Använd BankID på den här enheten",
  PASSKEY_AUTHENTICATE: "Sign in with passkey",
  PASSKEY_REGISTER: "Register with passkey",
  PASSKEY_LOGIN_FAILED: "Det gick inte att logga in med den passkeyn",
  PASSKEY_OPT_OUT: "Använd inte passkeys",
  PASSKEY_NOT_SUPPORTED: "Passkeys stöds inte på den här enheten",
  LOGIN_METHOD_DIVIDER: "ELLER",
  WITH_BANKID_QR_CODE: "Med BankID QR-kod",
  WITH_BANKID_SAME_DEVICE: "Med BankID på den här enheten",
  WITH_EMAIL: "Med e-post",
  WITH_PASSKEY: "Med Passkey",
  WITH_MAGIC_LOGIN: "Med 🪄Magic login🦄",
  CONFIRM_PASSWORD: "Bekräfta lösenord",
  CONFIRM_PASSWORD_PLACEHOLDER: "Bekräfta ditt lösenord",
  PASSWORDS_DO_NOT_MATCH: "Lösenorden matchar inte",
  CODE_RESENT_SUCCESS: "Koden har skickats till din e-post igen",
};

export const Translations = {
  en,
  sv,
};

export type Locale = keyof typeof Translations;
